module.exports = __webpack_public_path__ + "static/media/squall.966e4742.jpeg";